import { render } from "./PaymentSpoiler.vue?vue&type=template&id=731a9a40"
import script from "./PaymentSpoiler.vue?vue&type=script&lang=js"
export * from "./PaymentSpoiler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__